const _excluded = ["label", "maxCharacters", "rows", "value", "defaultValue", "onChangeValue", "preventMax"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { Text, TextField, Stack, getTheme } from 'office-ui-fabric-react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const LimitedTextField = _ref => {
  var _value$length;
  let {
      label,
      maxCharacters = Infinity,
      rows,
      value,
      defaultValue,
      onChangeValue,
      preventMax = false
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [textLength, setTextLength] = React.useState((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0);
  const handleOnChange = (_event, newValue) => {
    if (onChangeValue && newValue !== undefined) {
      onChangeValue(newValue);
    }
  };
  const theme = getTheme();
  React.useEffect(() => {
    var _value$length2;
    setTextLength((_value$length2 = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length2 !== void 0 ? _value$length2 : 0);
  }, [value]);
  const isOverMaxLength = textLength > maxCharacters;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, props), {}, {
      label: label,
      maxLength: preventMax ? maxCharacters : undefined,
      rows: rows,
      value: value,
      defaultValue: defaultValue,
      onChange: handleOnChange
    })), maxCharacters > 0 && textLength > 0 && /*#__PURE__*/_jsx(Stack, {
      styles: {
        root: {
          padding: '5px 10px 8px 10px',
          backgroundColor: isOverMaxLength ? theme.palette.red : theme.palette.neutralLighter,
          color: isOverMaxLength ? theme.palette.white : undefined
        }
      },
      children: /*#__PURE__*/_jsxs(Text, {
        variant: "smallPlus",
        children: [textLength, " of ", maxCharacters, " characters"]
      })
    })]
  });
};